/**
 * Created by Angelika on 14.09.2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-with-locales-es6';
import * as DEF from '../constants/defines';
import EpgItem from './EpgItem';

class EpgDetails extends Component {

    formatDate(date) {
        return moment(date).locale('ru').format('D MMMM YYYY');
    }

    render() {
        const {date, items, error} = this.props;
        const columnsCount = DEF.EPG_COLUMNS_COUNT;
        let columnLength = Math.round(items.length/columnsCount);
        let left = items.length - (columnsCount*columnLength);

        return (
            error ?
                <div className="epg-error">{error}</div>
                : <div className="epg">
                    <div className="epg-date">{this.formatDate(date)}</div>
                    <div className="epg-details">
                        {[...Array(columnsCount)].map((x, i) => {
                            let from = i * columnLength;
                            if (left > 0 && i > 0) {
                                from += left;
                            }
                            let to = from + columnLength;
                            if (left > 0 && i === 0) {
                                to += left;
                            }
                            let part = items.slice(from, to);

                            return (
                                <div key={i} className="epg-details-items">
                                    {part.map((item, index) => (
                                        <EpgItem key={index} item={item}/>
                                    ))}
                                </div>
                            )
                        })}

                    </div>
                </div>
        )
    }
}

EpgDetails.propTypes = {
    date: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    error: PropTypes.string
};

export default EpgDetails;


// WEBPACK FOOTER //
// ./src/components/EpgDetails.js